// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1KmcP","content":"styles_content__1AbhY","checkbox":"styles_checkbox__28w9w","checkboxLabel":"styles_checkboxLabel__1IEvF"};